import React from "react";
import { Box, TextField } from "@mui/material";

const OtpComponent = ({ otp, onOtpChange, length = 6 }) => {
  const handleChange = (e, index) => {
    const value = e.target.value;

    if (/^\d*$/.test(value) && value.length <= 1) {
      const otpArray = otp.split("");
      otpArray[index] = value;
      onOtpChange(otpArray.join(""));

      // Move to the next field
      if (value && index < length - 1) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && !otp[index]) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text")
      .slice(0, length)
      .split("");
    const otpArray = Array.from({ length }).map((_, i) => pastedData[i] || "");
    onOtpChange(otpArray.join(""));
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: "5px",
      }}
      onPaste={handlePaste}
    >
      {Array.from({ length }).map((_, index) => (
        <TextField
          key={index}
          type="text"
          id={`otp-input-${index}`}
          value={otp[index] || ""}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          variant="outlined"
          inputProps={{
            maxLength: 1,
            style: {
              textAlign: "center",
              fontSize: "14px",
              width: "25px",
              height: "20px",
            },
          }}
        />
      ))}
    </Box>
  );
};

export default OtpComponent;